import { createRoot, IReactRoot, TReactRenderTarget } from '@aytm/lib/common/reactCreateRoot'
import CompareItems from './components/CompareItems'
import { CompareItemsProps } from './types'

export default function render({
  target,
  props,
  clear
}: {
  target?: TReactRenderTarget
  props?: CompareItemsProps
  clear?: boolean
} = {}) {
  if ('development' === process.env.NODE_ENV) {
    // eslint-disable-next-line no-console
    console.debug('render CompareItems', props)
  }
  if (target) {
    if (clear) {
      ;(target as HTMLElement).innerHTML = ''
    }
    const root = createRoot(target)
    root.render(<CompareItems {...props} />)
    return root
  }
  return null
}

export function unlink(root: IReactRoot) {
  if ('development' === process.env.NODE_ENV) {
    // eslint-disable-next-line no-console
    console.debug('unlink CompareItems')
  }
  if (root) {
    root.unmount?.()
    return true
  }
  return false
}

export function update(root: IReactRoot, props: CompareItemsProps) {
  if ('development' === process.env.NODE_ENV) {
    // eslint-disable-next-line no-console
    console.debug('update CompareItems', props)
  }
  if (root) {
    root.render(<CompareItems {...props} />)
    return true
  }
  return false
}
